module.exports = __webpack_public_path__ + "d7b0502f81cb66694d599bd7c7342203.png";